// Shell-wide "Make time" state: which card or task the picker is open for. `m` on a card or task,
// the card's and task's buttons and the palette all open it through here.
import { useSyncExternalStore } from "react";
import type { FocusTarget } from "@shared/agenda";

export interface MakeTimeRequest {
  target: FocusTarget;
  /** Shown until the server answers with the title the block will carry. */
  title: string;
  /** A big card (U3): once the block is approved, the card waits under In progress. */
  lineUp?: boolean;
}

export interface MakeTimeState {
  open: boolean;
  request: MakeTimeRequest | null;
  /** Bumps on every open so the picker starts fresh. */
  seq: number;
}

let state: MakeTimeState = { open: false, request: null, seq: 0 };
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export const makeTimeStore = {
  open(request: MakeTimeRequest) {
    state = { open: true, request, seq: state.seq + 1 };
    emit();
  },
  close() {
    if (!state.open) return;
    state = { ...state, open: false };
    emit();
  },
  get(): MakeTimeState {
    return state;
  },
};

export function useMakeTimeState(): MakeTimeState {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
    () => state,
  );
}
